import React, { useState, useRef, useCallback } from 'react';
import PlaceholderBandera from 'containers/Mundial2026/assets/placeholders/Bandera.png';
import PlaceholderEscudo from 'containers/Mundial2026/assets/placeholders/Escudo.png';

const CountryCard = ({
  assets,
  country,
  countryName,
  onFavorite,
  translatedTexts,
  onClick,
}) => {
  const [tooltipPos, setTooltipPos] = useState(null);
  const wrapperRef = useRef(null);

  const handleMouseEnter = useCallback(() => {
    if (!wrapperRef.current) return;
    const rect = wrapperRef.current.getBoundingClientRect();
    setTooltipPos({
      x: rect.left + rect.width / 2,
      y: rect.top,
    });
  }, []);

  const handleMouseLeave = useCallback(() => {
    setTooltipPos(null);
  }, []);

  const tooltipText = country.favorite
    ? translatedTexts.TOOLTIP_REMOVE_FROM_FAVORITE
    : translatedTexts.TOOLTIP_ADD_TO_FAVORITE;

  return (
    <article
      className="wc-countries__card"
      onClick={onClick}
      style={{ cursor: 'pointer' }}
    >
      <span
        className="wc-countries__accent"
        style={{ background: country.colors[0] }}
      />

      <div className="wc-countries__crest">
        {country.crestUrl ? (
          <img
            className="wc-countries__crest-image"
            src={country.crestUrl}
            alt=""
            onError={e => {
              e.currentTarget.onerror = null;
              e.currentTarget.src = PlaceholderEscudo;
            }}
          />
        ) : (
          <span className="wc-countries__crest-fallback">
            {country.code || country.crest}
          </span>
        )}
      </div>

      <div className="wc-countries__flag" aria-hidden="true">
        {country.flagUrl ? (
          <img
            className="wc-countries__flag-image"
            src={country.flagUrl}
            alt=""
            onError={e => {
              e.currentTarget.onerror = null;
              e.currentTarget.src = PlaceholderBandera;
            }}
          />
        ) : (
          country.flagColors.map((color, index) => (
            <span
              key={`${country.id}-${index}-${color}`}
              className="wc-countries__flag-band"
              style={{ background: color }}
            />
          ))
        )}
      </div>

      <div className="wc-countries__separator" />

      <div className="wc-countries__name">{countryName}</div>

      <div
        ref={wrapperRef}
        className="wc-countries__favorite-wrapper"
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        <button
          type="button"
          className={`wc-countries__favorite${
            country.favorite ? ' wc-countries__favorite--active' : ''
          }`}
          aria-label={tooltipText}
          onClick={e => {
            e.stopPropagation();
            onFavorite(country.id);
          }}
        >
          <img
            src={
              country.favorite
                ? assets?.eventodeportivo_icono_agregarfavorito
                : assets?.eventodeportivo_icono_quitarfavorito
            }
            width={16}
            height={16}
            alt=""
          />
        </button>

        {tooltipPos && (
          <span
            className="wc-countries__favorite-tooltip"
            style={{
              position: 'fixed',
              left: tooltipPos.x,
              top: tooltipPos.y - 8,
              transform: 'translate(-50%, -100%)',
            }}
            aria-hidden="true"
          >
            {tooltipText}
          </span>
        )}
      </div>
    </article>
  );
};

export default CountryCard;
